import React from "react";
import { FormGroup, Label, Button } from "reactstrap";
import { X, Plus } from "lucide-react";

interface ArrayInputProps {
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
}

const ArrayInput: React.FC<ArrayInputProps> = ({
  label,
  values,
  onChange,
  placeholder = "Enter value",
}) => {
  const handleAdd = () => {
    onChange([...values, ""]);
  };

  const handleRemove = (index: number) => {
    onChange(values.filter((_, i) => i !== index));
  };

  const handleChange = (index: number, value: string) => {
    const newValues = [...values];
    newValues[index] = value;
    onChange(newValues);
  };

  return (
    <FormGroup>
      <div>
        <Label className="fw-bold">{label}</Label>
      </div>
      {values.map((value, index) => (
        <div key={index} className="d-flex mb-2">
          <input
            type="text"
            className="form-control"
            value={value}
            onChange={(e) => handleChange(index, e.target.value)}
            placeholder={placeholder}
          />
          <Button
            color="danger"
            outline
            className="ms-2"
            onClick={() => handleRemove(index)}
          >
            <X size={16} />
          </Button>
        </div>
      ))}
      <Button color="secondary" outline onClick={handleAdd}>
        <Plus size={16} className="me-1" />
        Add {label}
      </Button>
    </FormGroup>
  );
};

export default ArrayInput;
